import type {ItemId} from "../../models/GroupRepo";

// Recipes match when their name matches `query` and they use every item in `itemIds`.
export type RecipeSearch = {query: string; itemIds: ItemId[]};

export const isActiveSearch = (search: RecipeSearch | null) =>
  search !== null && (search.query.trim() !== "" || search.itemIds.length > 0);
